import React, { Component } from 'react'
import { Button, Col, Input, Row, Label } from 'reactstrap'
import Card from '../../comum/components/Card'
import { observer } from 'mobx-react'
import { Select } from 'react-select'
import { observable } from "mobx"
import LoadingImage from '../../comum/components/LoadingImage';
import InputFiltro from '../../comum/components/InputFiltro';
import FormSelect from '../../comum/components/FormSelect';
import FormSelectSimples from '../../comum/components/FormSelectSimples'
import { IconeCarregar, IconeDelete, IconeProibido } from '../../comum/components/Icones'
import ModalForm from '../../comum/components/ModalForm';
import ModalAviso from '../../comum/components/ModalAviso'
import FormInput from "../../comum/components/FormInput";
import CheckboxDetalhado from '../../comum/components/CheckboxDetalhado'
import Checkbox from '../../comum/components/Checkbox'

@observer
export default class FiltroEmailFaturamento extends Component {


    constructor(props) {
        super(props)
        this.controller = this.props.controller
    }

    modalCriarEmail() {
        if (this.controller.mostrarModalNovoEmail) {
            return (
                <ModalForm
                    className="tamanho-modal-500"
                    onClickCancelar={() => {
                        this.controller.novoEmail.Email = '';
                        this.controller.listaEmail = [];
                        this.controller.validateEmailMessage = "";
                        this.controller.mostrarModalNovoEmail = false;
                    }}
                    onClickSalvar={() => {
                        if (!this.controller.aplicarMesmoRadical) {
                            this.controller.CadastrarListaEmails(this.controller.listaEmail, this.controller.aplicarMesmoRadical)
                        }
                        else {
                            this.controller.mostrarModalSelecaoRadical = true;
                            this.controller.listarCnpjsPertentencesMesmoRadical(this.controller.clienteSelecionado.cnpj)
                        }
                    }}
                    salvando={false}
                    habilitaSalvar={this.controller.listaEmail.length !== 0}

                >
                    <div>
                        <h2>Novo Email</h2>
                        <p className="text-danger">{this.controller.validateEmailMessage}</p>
                        <Row>
                            <Input
                                className="w-100"
                                type="text"
                                onChange={this.controller.setNovoEmail}
                                placeholder="exemplo@email.com"
                                value={this.controller.novoEmail.Email}
                            />
                            <Button
                                disabled={this.controller.loadingRelatorio}
                                className="w-100"
                                onClick={() => {

                                    if (!this.controller.validateValidEmail(this.controller.novoEmail.Email)) {
                                        this.controller.validateEmailMessage = "Email inválido";
                                        return
                                    }
                                    if (this.controller.emailAlreadyExistsOnNewEmailList(this.controller.novoEmail.Email)) {
                                        this.controller.validateEmailMessage = "Email já adicionado à lista de novos emails";
                                        return
                                    }
                                    if (this.controller.emailAlreadyRegisteredOnGroupEmail(this.controller.novoEmail.Email)) {
                                        this.controller.validateEmailMessage = "Email já cadastrado no grupo de emails";
                                        return
                                    }
                                    this.controller.validateEmailMessage = "";
                                    this.controller.listaEmail.push(this.controller.novoEmail.Email.toLowerCase())
                                    this.controller.listaEmail = [...new Set(this.controller.listaEmail)];
                                    this.controller.novoEmail.Email = "";


                                }}>
                                {
                                    this.controller.loadingRelatorio
                                        ? <IconeCarregar cor="#fff" className="my-0" tamanho="1x" />
                                        : "Adicionar"
                                }
                            </Button>

                        </Row>
                        {this.controller.listaEmail.map(email => {
                            return (<Row>
                                <Col xs={9}> <Label>{email}</Label> </Col>
                                <Col><IconeProibido cor="#fff" className="my-0" tamanho="1x" onClick={() => { this.controller.listaEmail = this.controller.arrayRemove(this.controller.listaEmail, email) }} />
                                </Col>
                            </Row>)
                        })}
                    </div>
                </ModalForm>
            )
        }
    }

    modalMensagemSucesso = () => {
        return (
            this.controller.mostrarModalSucesso &&
            <ModalAviso onClickFechar={this.controller.fecharTodosModais}>
                <h2>Mensagem</h2>
                <span>{this.controller.modalMensagem}</span>
            </ModalAviso>
        );
    }

    modalMensagemErro = () => {
        return (
            this.controller.mostrarModalFalha &&
            <ModalAviso onClickFechar={this.controller.fecharTodosModais}>
                <h2>Falha</h2>
                <span>{this.controller.modalMensagem}</span>
            </ModalAviso>
        );
    }

    ModalConfirmacaoExclusao = () => {

    }
    ModalRadicalSelect() {
        if (this.controller.mostrarModalSelecaoRadical) {
            return (<ModalForm salvando={this.controller.excluindoNotas}
                labelCancelar="Fechar"
                labelConfirmar="Próximo"
                habilitaSalvar={this.controller.cnpjsPertentencesMesmoRadical.length > 0}
                onClickCancelar={() => { this.controller.mostrarModalSelecaoRadical = false; this.controller.cnpjsPertentencesMesmoRadical = [] }}
                onClickSalvar={() => { this.controller.mostrarModalSelecaoRadical = false; this.controller.mostrarModalConfirm = true }}>
                <h2>Clique para remover os radicais que não serão aplicados</h2>
                <p>Lista de Cnpjs que serão inseridos os novos e-mails</p>
                {!this.controller.loadingCnpjsMesmoRadical ?
                    this.controller.cnpjsPertentencesMesmoRadical.map(cliente => {
                        return (<Row>
                            <Col xs={9}> <Label>{cliente.Razao}</Label> </Col>
                            <Col> <IconeProibido title={"Excluir"} tamanho="lg" className="m-2" onClick={() => {
                                this.controller.cnpjsPertentencesMesmoRadical = this.controller.arrayRemove(this.controller.cnpjsPertentencesMesmoRadical, cliente)
                                if (this.controller.cnpjsPertentencesMesmoRadical == 0) { this.controller.fecharTodosModais() }
                            }} /> </Col>
                        </Row>)
                    }) : <LoadingImage />
                }
            </ModalForm>
            )
        }

    }

    ModalRadicalConfirm() {
        if (this.controller.mostrarModalConfirm) {
            return (<ModalForm salvando={this.controller.excluindoNotas}
                labelCancelar="Não, quero voltar"
                labelConfirmar="Sim desejo aplicar"
                habilitaSalvar={this.controller.cnpjsPertentencesMesmoRadical.length > 0 && this.controller.loadingAplicandoSalvarEmail === false}
                onClickCancelar={() => { this.controller.mostrarModalSelecaoRadical = true; this.controller.mostrarModalConfirm = false }}
                onClickSalvar={() => this.controller.CadastrarListaEmails(this.controller.listaEmail, this.controller.aplicarMesmoRadical)}>
                <h2 className="text-danger">ATENÇÃO : Deseja realmente realizar as operações em todos os Radicais?</h2>
                <p>Cnpjs que serão aplicados</p>
                {!this.controller.loadingCnpjsMesmoRadical ?
                    this.controller.cnpjsPertentencesMesmoRadical.map(cliente => {
                        return (<Row>
                            <Col xs={9}> <Label className="text-danger">{cliente.Razao}</Label> </Col>
                        </Row>)
                    }) : <LoadingImage />
                }
                {this.controller.loadingAplicandoSalvarEmail && <div>
                    <p>Aplicando alterações </p><IconeCarregar cor="#001C43" className="my-0" tamanho="1x" />
                </div>
                }
            </ModalForm>
            )
        }

    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-10`}>
                    <Row className="pb-0">
                        {this.modalCriarEmail()}
                        {this.ModalRadicalSelect()}
                        {this.ModalRadicalConfirm()}
                        {this.modalMensagemSucesso()}
                        {this.modalMensagemErro()}
                        <FormSelectSimples titulo="Categoria" xs={12} sm={12} md={4} lg={4} xl={3}
                            itens={this.controller.listaCategorias}
                            dado={this.controller.categoriaSelecionado}
                            onChange={this.controller.setCategoria}
                            bloqueado={this.controller.listaCategorias.length === 0}
                        />

                        <InputFiltro xs={12} sm={12} md={4} lg={4} xl={3}
                            titulo={"Filtrar por CNPJ ou Razão (pressione Enter)"}
                            value={this.controller.textoFiltroCliente}
                            onChange={this.controller.setTextoFiltroCliente}
                            onEnter={this.controller.listarClientes}

                        />

                        {this.controller.loadingClientes ? (
                            <Col className={"mb-4 w-100"} xs={12} sm={12} md={4} lg={4} xl={3}>
                            <div className="w-100">
                                <Col xs={12} className="col-label px-0">
                                    <Label>Carregando Clientes</Label>
                                </Col>
                                <Col xs={12} className="px-0">
                                    <IconeCarregar cor="#001C43" className="my-0" tamanho="1x" />
                                </Col>
                            </div>
                        </Col>
                        )  : 
                        (
                            <FormSelectSimples titulo={`${this.controller.listaClientes.length} clientes encontrados`} xs={12} sm={12} md={4} lg={4} xl={3}
                            itens={this.controller.listaClientes}
                            dado={this.controller.clienteSelecionado}
                            onChange={this.controller.setCliente}
                            bloqueado={this.controller.listaClientes.length === 0}
                            naoPreencherAutomaticamenteCasoApenasUmRegistro={true}
                        />
                        )}




                        {
                            // this.controller.loadingClientes
                            //     ? <IconeCarregar cor="#fff" className="my-0" tamanho="1x" />
                            //     : "Filtrar"
                        }

                        {/* <SelectFiltro xs={12} sm={6} md={6} lg={4} xl={4}
                            titulo="Navio"
                            itens={this.controller.naviosCE}
                            valor={this.controller.navioSelecionado}
                            naoLimpar={true}
                            itensValor="Ce" itensLabel="Navio"
                            onChange={this.controller.setNavio}
                        /> */}
                        <Col className="col-botoes">
                            <Button
                                disabled={this.controller.loadingRelatorio || this.controller.clienteSelecionado === null || this.controller.categoriaSelecionado === null}
                                className="btn-com-bordas-primary btn-filtrar"
                                onClick={() => { this.controller.pesquisar2(this.controller.clienteSelecionado, this.controller.categoriaSelecionado, this.controller.clienteSelecionado.clientId,this.controller.clienteSelecionado) }}>
                                {
                                    this.controller.loadingRelatorio
                                        ? <IconeCarregar cor="#fff" className="my-0" tamanho="1x" />
                                        : "Carregar"
                                }
                            </Button>
                        </Col>
                        <Checkbox onClick={() => this.controller.aplicarMesmoRadical = !this.controller.aplicarMesmoRadical}
                            ativo={this.controller.aplicarMesmoRadical}
                            bloqueado={false}
                            valor="aplicar operação para os cnpjs do mesmo radical"
                        />
                    </Row>
                </Card>


            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/components/FiltroEmailFaturamento.js